import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  trucksList : [],
  truckData : null,
  editTruckData : null,
  deleteMessage : null,
  error : null
};


export const TRUCK_API = "admin/truck";

export const getTrucksList = createAsyncThunk(
    TRUCK_API,
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(TRUCK_API, {
          params : formData
        });
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getTruckById = createAsyncThunk(
    TRUCK_API + '/get-truck-by-id',
    async (id, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(TRUCK_API + '/' + id);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const createTruck = createAsyncThunk(
    TRUCK_API + '/create',
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(TRUCK_API, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const updateTruck = createAsyncThunk(
    TRUCK_API + '/update-truck',
    async (data, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(TRUCK_API + '/' + data?.id, data);
        if (response.data) {
          return response.data;
        } else {
            console.log(response, 'response')
          return rejectWithValue(response.data || "Error");
        }
      } catch (error) {
        console.log(error, 'errors')
        return rejectWithValue(
          error.response?.data || "Error"
        );
      }
    }
);

export const deleteTruck = createAsyncThunk(
    TRUCK_API + '/delete',
    async (id, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        // const id = formData.get('id')
        const response = await axiosInstance.delete(TRUCK_API + '/' + id);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

const truckSlice = createSlice({
    name : "truck",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(getTrucksList.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getTrucksList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.trucksList = action.payload;
            })
            .addCase(getTrucksList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(createTruck.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createTruck.fulfilled, (state, action) => {
                state.isLoading = false;
                state.truckData = action.payload;
            })
            .addCase(createTruck.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(updateTruck.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateTruck.fulfilled, (state, action) => {
                state.isLoading = false;
                state.editTruckData = action.payload;
            })
            .addCase(updateTruck.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteTruck.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deleteTruck.fulfilled, (state, action) => {
                state.isLoading = false;
                state.deleteMessage = action.payload;
            })
            .addCase(deleteTruck.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getTruckById.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getTruckById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.editTruckData = action.payload;
            })
            .addCase(getTruckById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default truckSlice.reducer